import * as React from "react";
import { cn } from "@/lib/utils";

const AutoResizeTextarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, value, defaultValue, onChange, ...props }, forwardedRef) => {
  const innerRef = React.useRef<HTMLTextAreaElement>(null);

  const ref = (forwardedRef as React.RefObject<HTMLTextAreaElement>) ?? innerRef;

  const resize = React.useCallback(() => {
    const el = (ref as React.RefObject<HTMLTextAreaElement>).current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [ref]);

  React.useEffect(() => {
    resize();
  }, [value, resize]);

  React.useEffect(() => {
    resize();
  }, []);

  return (
    <textarea
      spellCheck={true}
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onInput={resize}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none overflow-hidden",
        className,
      )}
      {...props}
    />
  );
});

AutoResizeTextarea.displayName = "AutoResizeTextarea";

export { AutoResizeTextarea };
